import { Component, OnInit, ViewChild, ViewContainerRef, NgModule, Compiler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { AppComponent } from '../../app.component';
import { ConsentMainComponent } from './consent-main.component';
import { DisplayService } from '../../service/display.service';
import { TokenManager } from '../../service/web-api.service';
import { AuthService } from '../../service/auth.service';
import { CustomViewService } from '../../service/custom-view.service';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

declare let gtag: any; // グローバル変数gtagを解決

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  providers: [DisplayService, CustomViewService]
})
export class ConsentComponent implements OnInit {

  // 画面ID
  readonly SCREEN_ID = 'O04';

  /** 認可を求めているクライアント名 */
  clientName: string;

  /** 認可を求めているクライアントURL */
  clientLogoUri: string;

  /** 認可が求められているサービス名 */
  dispZ0002: string;

  /** 認可が求められているスコープ説明の配列 */
  scopes: string[];

  /** 認可が求められているOIDCスコープ説明の配列 */
  oidcScopes: string[];

  /** タイトルロゴ */
  dispZ0001: string;

  /** リソース表示名 */
  displayResourceName: string;

  /** リソース表示名(複数) */
  displayResourceNames: string[];

  // ページ番号定義
  public pageNo: number;

  // 操作クラス定義
  public comp: ConsentMainComponent;

  // テンプレートファイ名（HTML）
  public templateHtml: string;

  // テンプレートファイル（CSS）
  public templateCss: string;

  // 画面資材ルートURL
  public assetsBaseUrl: string;

  // 共通画面資材URL
  public assetsPortalBaseUrl: string;

  // サービス名
  public serviceName: string;


  @ViewChild('waitModal', { static: false }) waitModal: WaitModalComponent;
  @ViewChild('confirmModal', { static: false }) confirmModal: ConfirmModalComponent;
  @ViewChild('dest', { read: ViewContainerRef, static: false })
  public dest: ViewContainerRef;

  constructor(
    private displayService: DisplayService,
    private authService: AuthService,
    private appComponent: AppComponent,
    private customViewService: CustomViewService,
    private compiler: Compiler,
    public translateService: TranslateService) { }

  /**
   * 初期処理
   */
  async ngOnInit() {
    this.pageNo = 1;

    if (this.appComponent.dispZ0000 === undefined) {
      await this.appComponent.getDisplayInfo();
    }

    // 読み込まれるHTML名の取得
    this.serviceName = '';
    if (this.appComponent.dispZ0000 === '') {
      this.serviceName = 'portal';
    } else {
      this.serviceName = this.appComponent.dispZ0000;
    }

    this.assetsBaseUrl = environment.storageBaseUrl + '/' + this.serviceName + '/adume';
    this.assetsPortalBaseUrl = environment.storageBaseUrl + '/portal';
    this.templateHtml = this.assetsBaseUrl + '/html/consent/' + this.serviceName + '_consent';
    this.templateCss = this.assetsBaseUrl + '/css/' + this.serviceName + '_consent.css';

    // 画面カスタマイズ情報
    await this.displayService.execAuthDisplayInfo(this.SCREEN_ID).subscribe(data => {
      this.dispZ0001 = '';
      this.dispZ0002 = '';
      if (data.displayInfo != null) {
        if (data.displayInfo.Z0001 != null) {
          this.dispZ0001 = data.displayInfo.Z0001;
        }
        if (data.displayInfo.Z0002 != null) {
          this.dispZ0002 = data.displayInfo.Z0002;
        }
      }

      this.clientName = data.clientName;
      this.clientLogoUri = data.clientLogoUri;
      this.scopes = data.scopes;
      this.oidcScopes = data.oidcScopes;
      this.displayResourceName = data.displayResourceName;
      if (this.displayResourceName !== undefined && this.displayResourceName !== null) {
        this.displayResourceNames = this.displayResourceName.split(',');
      }

      // カスタムページ表示
      this.directInjection();
    });
  }

  /**
  * コンポーネントを生成し親コンポーネントに挿入する
  *
  */
  public async directInjection() {

    gtag('config', environment.analyticsId, {
      'page_path': '/html/consent/' + this.serviceName + '_consent' + '/' + this.pageNo,
      'page_title': 'consent',
    });

    gtag('config', environment.analyticsIdGa4, {
      'page_title': 'consent',
      'page_location': this.serviceName + '/consent/' + this.pageNo
    });

    // 元の要素をクリアする
    this.dest.clear();

    // テンプレートを取得
    let templateHtmlText = await this.customViewService.getText(this.templateHtml + '_' + this.pageNo + '.html').toPromise();
    let templateCssText = await this.customViewService.getText(this.templateCss).toPromise();
    templateCssText = templateCssText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsPortalBaseUrl}}/g, this.assetsPortalBaseUrl);


    // Angular コンポーネントを用意する
    @Component({
      selector: 'app-consent-main',
      template: templateHtmlText,
      styles: [templateCssText],
    })

    class ConsentModuleComponent extends ConsentMainComponent { }
    // Angular モジュールを用意する

    @NgModule({
      imports: [CommonModule, FormsModule, PopoverModule.forRoot()],
      declarations: [ConsentModuleComponent],
      exports: [ConsentModuleComponent]
    })
    class ConsentModule {
    }

    // Angular モジュールとコンポーネントをコンパイルする
    const module = this.compiler.compileModuleAndAllComponentsSync(ConsentModule);
    // Angular モジュールから ConsentModuleComponent を生成するファクトリを取り出す
    const factory = module.componentFactories.find((c) => {
      return c.componentType === ConsentModuleComponent;
    });

    // ConsentModuleComponent を生成し this.dest に設定する
    const componentRef = this.dest.createComponent(factory);

    // componentのインスタンスを取得する。
    this.comp = (<ConsentModuleComponent>componentRef.instance);
    this.comp.init(this, this.authService, this.waitModal, this.confirmModal);
  }
}
